import cats from '@/data/cats'
import dogs from '@/data/dogs'
import notes from '@/data/notes'
import score from '@/data/score'
import score2 from '@/data/little_star'
// import scale from '@/data/scale.mp3'
import { Howl } from 'howler'

var howlSound = new Howl({
  src: ['xylophone.mp3'],
  sprite: {
    do: [750 * 0 + 0, 750],
    re: [750 * 1 + 60, 740],
    mi: [750 * 2 + 60, 740],
    fa: [750 * 3 + 60, 740],
    sol: [750 * 4 + 60, 740],
    la: [750 * 5 + 60, 740],
    ti: [750 * 6 + 60, 740],
    doo: [750 * 7 + 60, 740]
  }
})

// howlSound.play()

function CreateSoundHelper () {
  this.audioCtx = new (window.AudioContext || window.webkitAudioContext)()
  this.oscillator = this.audioCtx.createOscillator()
  this.gainNode = this.audioCtx.createGain()
  this.oscillator.connect(this.gainNode)
  this.oscillator.frequency.value = 440
  this.hasStarted = false
  this.howlSound = howlSound
  this.playSound2 = (frequency, solfege, duration) => {
    // if (!this.hasStarted) {
    //   this.hasStarted = true
    //   this.oscillator.start()
    // }
    // this.oscillator.frequency.value = frequency
    // this.gainNode.connect(this.audioCtx.destination)
    // setTimeout(() => this.gainNode.disconnect(this.audioCtx.destination), duration)
    // howlSound.play(solfege)
  }
}

CreateSoundHelper.prototype.howlSound = howlSound

CreateSoundHelper.prototype.playSound = function (frequency, solfege, duration) {
  // if (!this.hasStarted) {
  //   this.hasStarted = true
  //   this.oscillator.start()
  // }
  // this.oscillator.frequency.value = frequency
  // this.gainNode.connect(this.audioCtx.destination)
  // setTimeout(() => this.gainNode.disconnect(this.audioCtx.destination), duration)
  // eslint-disable-next-line no-debugger
  this.howlSound.play(solfege)
}

CreateSoundHelper.prototype.playSound = function (frequency, solfege, duration) {
  // if (!this.hasStarted) {
  //   this.hasStarted = true
  //   this.oscillator.start()
  // }
  // this.oscillator.frequency.value = frequency
  // this.gainNode.connect(this.audioCtx.destination)
  // setTimeout(() => this.gainNode.disconnect(this.audioCtx.destination), duration)
  // eslint-disable-next-line no-debugger
  this.howlSound.play(solfege)
}

var soundHelper = new CreateSoundHelper()

export default {
  cats,
  dogs,
  score,
  score2,
  pets: [...cats, ...dogs],
  notes,
  soundHelper,
  howlSound
}
